import { cn } from "@msuite/ui/utils";
import type { PropsWithChildren } from "react";
import { useMemo } from "react";
import { useCapacityCalendarContext } from "./context";

/** Props Interface */
interface CapacityCalendarRowWrapperProps extends PropsWithChildren {
	variant: "header" | "group" | "content" | "sub";
}

export function CapacityCalendarRowWrapper({ children, variant }: CapacityCalendarRowWrapperProps) {
	/** Context */
	const { controller } = useCapacityCalendarContext();

	/** Memoized */
	const style = useMemo(
		() => ({
			gridTemplateColumns: controller.constants.gridTemplateColumns,
			gridAutoRows: "1fr",
		}),
		[controller.constants.gridTemplateColumns],
	);

	/** Render */
	return (
		<div
			className={cn(
				"grid relative",
				"border-b-[0.5px] border-color",
				"*:border-r-[0.5px] *:border-color *:p-2",
				"items-center",
				variant === "sub" ? "min-h-8" : "min-h-10",
				// A group bar separates the rows beneath it from the ones above and carries no day of
				// its own, so it is tinted rather than drawn as another record.
				variant === "group" && "bg-gray-50 dark:bg-zinc-900/50",
				`capacity-calendar-row-${variant}`,
			)}
			style={style}
		>
			{children}
		</div>
	);
}
